var React = require('react');

function Bold (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z","key":0}),React.createElement("path",{"d":"M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z","key":1})]);
}

Bold.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-bold"};

module.exports = Bold;

Bold.default = Bold;
